var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M27.4001 20.9377C26.9876 24.2627 24.2626 26.9877 20.9376 27.4002C18.9251 27.6502 17.0501 27.1002 15.5876 26.0252C14.7501 25.4127 14.9501 24.1127 15.9501 23.8127C19.7126 22.6752 22.6751 19.7002 23.8251 15.9377C24.1251 14.9502 25.4251 14.7502 26.0376 15.5752C27.1001 17.0502 27.6501 18.9252 27.4001 20.9377Z",
          fill: _vm.color
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M12.4875 2.5C6.975 2.5 2.5 6.975 2.5 12.4875C2.5 18 6.975 22.475 12.4875 22.475C18 22.475 22.475 18 22.475 12.4875C22.4625 6.975 18 2.5 12.4875 2.5ZM11.3125 11.0875L14.325 12.1375C15.4125 12.525 15.9375 13.2875 15.9375 14.4625C15.9375 15.8125 14.8625 16.925 13.55 16.925H13.4375V16.9875C13.4375 17.5 13.0125 17.925 12.5 17.925C11.9875 17.925 11.5625 17.5 11.5625 16.9875V16.9125C10.175 16.85 9.0625 15.6875 9.0625 14.2375C9.0625 13.725 9.4875 13.3 10 13.3C10.5125 13.3 10.9375 13.725 10.9375 14.2375C10.9375 14.6875 11.2625 15.05 11.6625 15.05H13.5375C13.825 15.05 14.05 14.7875 14.05 14.4625C14.05 14.025 13.975 14 13.6875 13.9L10.675 12.85C9.6 12.475 9.0625 11.7125 9.0625 10.525C9.0625 9.175 10.1375 8.0625 11.45 8.0625H11.5625V8.0125C11.5625 7.5 11.9875 7.075 12.5 7.075C13.0125 7.075 13.4375 7.5 13.4375 8.0125V8.0875C14.825 8.15 15.9375 9.3125 15.9375 10.7625C15.9375 11.275 15.5125 11.7 15 11.7C14.4875 11.7 14.0625 11.275 14.0625 10.7625C14.0625 10.3125 13.7375 9.95 13.3375 9.95H11.4625C11.175 9.95 10.95 10.2125 10.95 10.5375C10.9375 10.9625 11.0125 10.9875 11.3125 11.0875Z",
          fill: _vm.color
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }